<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <loading-spinner v-if="loading"></loading-spinner>
      <div v-else>
        <div
          v-if="!locations.length"
          class="background-color ion-color-warning ion-padding ion-text-center"
        >
          There are no locations available.
        </div>
        <ion-list v-else>
          <ion-item
            v-for="location in locations"
            v-bind:key="`location-${location.id}`"
            @click="chooseLocation(location)"
            detail
            :data-cy="`location-${location.id}`"
          >
            <ion-avatar slot="start">
              <img :src="location.photoURL" />
            </ion-avatar>
            <ion-label>
              <h2>{{ location.name }}</h2>
              <p>{{ location.city }}, {{ location.state }}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
    <available-order-footer></available-order-footer>
  </ion-page>
</template>

<script>
import errorAlert from "@/ErrorAlert";
import { mapMutations } from "vuex";
import LocationModelService from "@/services/LocationModel";

export default {
  title: "Locations",

  data: function() {
    return {
      loading: true,
      locations: []
    };
  },

  created() {
    let q = LocationModelService.acceptingOrdersQuery();
    q.get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.locations.push(doc.data());
        });
      })
      .catch(e => {
        errorAlert(e.message);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapMutations("order", ["setOrderLocation"]),

    chooseLocation(location) {
      this.setOrderLocation(location);
      this.$router.push({ name: "App: Location Menu" }).catch(e => e);
    }
  }
};
</script>
